/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerGetItemRerunStatusQueryResponse, ApplicationsControllerGetItemRerunStatusPathParams, ApplicationsControllerGetItemRerunStatus400, ApplicationsControllerGetItemRerunStatus401, ApplicationsControllerGetItemRerunStatus403, ApplicationsControllerGetItemRerunStatus404 } from "../../models/checklistsController/ApplicationsControllerGetItemRerunStatus";

function getApplicationsControllerGetItemRerunStatusUrl(id: ApplicationsControllerGetItemRerunStatusPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-applications/${id}/item-rerun` as const }  
  return res
}

/**
 * @description Reports why a whole-application rerun or a section, question or subquestion rerun is blocked. Requires the custom-reviews-playbooks flag for the organization.
 * @summary Whether the caller can rerun this application or its individual items
 * {@link /api/v1/checklist-applications/:id/item-rerun}
 */
export async function applicationsControllerGetItemRerunStatus(id: ApplicationsControllerGetItemRerunStatusPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerGetItemRerunStatusQueryResponse, ResponseErrorConfig<ApplicationsControllerGetItemRerunStatus400 | ApplicationsControllerGetItemRerunStatus401 | ApplicationsControllerGetItemRerunStatus403 | ApplicationsControllerGetItemRerunStatus404>, unknown>({ method : "GET", url : getApplicationsControllerGetItemRerunStatusUrl(id).url.toString(), ... requestConfig })  
  return res.data
}